import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines, productShortName } from '../data/offer';
export function ClosingSection() {
  return <section className="tech-grid bg-navy-950 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-53" data-mp="12t3stjme3hm5">
      <div className="mx-auto max-w-4xl px-4" data-id="element-54" data-mp="xt8yf63eo9wc">
        <div className="text-center" data-id="element-55" data-mp="xsfra40jbido">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-56" data-mp="1cqrp4dzn8x6f">
            El próximo lunes puedes seguir improvisando...
          </h2>
          <p className="mt-4 font-display text-2xl font-extrabold text-leaf-400 sm:text-3xl" data-id="element-57" data-mp="1lj3dzvf40cka">
            O puedes entrar al aula con todo listo desde hoy.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-58" data-mp="1hk419on4zbia">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-lg border-l-4 border-leaf-500 bg-navy-900 px-4 py-3 text-sm font-semibold text-navy-50" data-id="element-59" data-mp="1qifvs1r4itg0" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-leaf-400" aria-hidden="true" data-id="element-60" data-mp="2gd6gxb7wl82b" />
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-61" data-mp="2qa1ftv839ah4">
          <p className="leading-relaxed text-navy-200" data-id="element-62" data-mp="2q8go0dd5s5my">
            El {productShortName} no te convierte en mejor docente. Vos ya eres un buen docente.
          </p>
          <p className="mt-3 text-lg font-bold text-white" data-id="element-63" data-mp="2zz2wlnmgjvw5">
            Lo que hace el megapack es darte el tiempo y las herramientas para que eso se note en cada clase.
          </p>
        </div>
      </div>
    </section>;
}